import React from "react";
import { InverntroyService } from "../../../../services/api/inventroy.service";
import toast from "react-hot-toast";
import { AuthService } from "../../../../services/api";

interface PrepareOrderButtonProps {
  clinicId: string;
  orderId: number;
  onSuccess:any;
}

const AssignDriver: React.FC<PrepareOrderButtonProps> = ({
  clinicId,
  orderId,
  onSuccess
}) => {
  console.log(clinicId, orderId);
  const handleDriverAssign = async () => {
    try {
      const data = {
        clinicId,
        orderId,
      };
      const response = await InverntroyService.assignDriver(data);
      if (!response.status) {
          throw new Error("Failed to assign driver");
        }

        console.log(response);
        const { updatedData } = response;
        const { patient_id, order_number, order_address, order_pincode,delivery_person_id } = updatedData;

        // Send notification to patient
        await sendNotification(
          "Order Prepared by clinic",
          `Your order #${order_number} has been successfully prepared and assigned to a driver.`,
          patient_id,
          "Patient"
        );

        // Send notification to driver (using same patient_id? Is this correct?)
        await sendNotification(
          "New Order Received",
          `New Order to deliver at ${order_address}, ${order_pincode}`,
          delivery_person_id,
          "Driver"
        );

        toast.success("Driver assigned successfully");
        onSuccess();
      } catch (error) {
        console.error("Error in assigning driver:", error);
        toast.error(`Error in assigning driver: ${error instanceof Error ? error.message : String(error)}`);
      }
  };

  const sendNotification = async (title: string, message: string, userId: string,userRole:string) => {
    try {
      const tokens = await AuthService.fetchNotificationTokens(userId);
        await AuthService.sendNotification(title, message, tokens);
      try {
        await AuthService.createNotification(title, message, userId, userRole);
      } catch (dbNotifyErr) {
        console.error("Error creating notification record:", dbNotifyErr);
      }
    } catch (error) {
      console.error(`Failed to send notification (${title}):`, error);
    }
  };
  return (
    <button
      onClick={handleDriverAssign}
      className={`bg-green-600 hover:bg-green-700 text-white font-medium text-sm px-4 py-2 rounded-l`}
    >
      Assign Driver
    </button>
  );
};

export default AssignDriver;
